import * as Yup from 'yup';

export const schema = challenge =>
	Yup.object().shape({
		title: Yup.string()
			.min(2, { id: 'too-short', value: 2 })
			.max(70, { id: 'too-long', value: 70 })
			.required({ id: 'required' }),
		...(challenge.isSubmissionConsentRequired() && {
			consent: Yup.boolean().oneOf([true], { id: 'required' }),
		}),
	});
